module.exports = __webpack_public_path__ + "static/WuFan.6bde6a63.png";